"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[501],{

/***/ 9305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Bag; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var index_esm = __webpack_require__(6893);
// EXTERNAL MODULE: ./src/themes/default/components/Delivery/index.tsx + 1 modules
var Delivery = __webpack_require__(3206);
// EXTERNAL MODULE: ./src/themes/default/components/Button/index.tsx + 3 modules
var Button = __webpack_require__(5219);
// EXTERNAL MODULE: ./src/utils/formatCurrency.ts
var formatCurrency = __webpack_require__(2894);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
;// CONCATENATED MODULE: ./src/themes/default/components/Bag/components/Resume/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  gap: ",
        ";\n  padding: ",
        " ",
        ";\n\n  border-top: 1px solid ",
        ";\n  font-size: ",
        ";\n\n  @media (max-width: 768px) {\n    font-size: ",
        ";\n    padding: ",
        ";\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: bold;\n  text-transform: uppercase;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}

const Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b437e2e1-0"
})(_templateObject(), (p)=>p.theme.spacing.small, (p)=>p.theme.spacing.medium, (p)=>p.theme.spacing.large, (p)=>p.theme.colors.border, (p)=>p.theme.font.small, (p)=>p.theme.font.xSmall, (p)=>p.theme.spacing.medium);
const Line = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b437e2e1-1"
})(_templateObject1());
const Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b437e2e1-2"
})(_templateObject2());
const Value = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b437e2e1-3"
})(_templateObject3());

;// CONCATENATED MODULE: ./src/themes/default/components/Bag/components/Resume/index.tsx



const Resume = (param)=>{
    let { shippingSelected , total =0 , discount  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Line, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        children: "subtotal"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Value, {
                        children: (0,formatCurrency/* formatCurrency */.x)(total)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Line, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        children: "desconto"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Value, {
                        children: discount > 0 ? (0,formatCurrency/* formatCurrency */.x)(discount) : "Calculado no pagamento"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Line, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        children: "frete"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Value, {
                        children: shippingSelected ? (0,formatCurrency/* formatCurrency */.x)(shippingSelected.price) : "-"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Line, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        children: "total"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Value, {
                        children: (0,formatCurrency/* formatCurrency */.x)((total || 0) + ((shippingSelected === null || shippingSelected === void 0 ? void 0 : shippingSelected.price) || 0))
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-icons/io5/index.esm.js
var io5_index_esm = __webpack_require__(155);
;// CONCATENATED MODULE: ./src/hooks/useDebounce.ts

function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = (0,react.useState)(value);
    (0,react.useEffect)(()=>{
        const timer = setTimeout(()=>setDebouncedValue(value), delay || 500);
        return ()=>{
            clearTimeout(timer);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
}
/* harmony default export */ var hooks_useDebounce = (useDebounce);

;// CONCATENATED MODULE: ./src/themes/default/components/Bag/components/Products/styles.ts

function styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  overflow: auto;\n  flex-direction: column;\n  padding: ",
        " 0;\n\n  font-size: ",
        ";\n\n  @media (max-width: 768px) {\n    font-size: ",
        ";\n  }\n"
    ]);
    styles_templateObject = function() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 40px;\n  height: 40px;\n  border: 1px solid ",
        ";\n  flex-shrink: 0;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: ",
        ";\n  color: ",
        ";\n\n  & svg {\n    width: 50%;\n    height: 50%;\n  }\n"
    ]);
    styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n"
    ]);
    styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 100%;\n\n  flex: 1;\n\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n\n  > span {\n    font-weight: 600;\n    white-space: normal;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n  }\n\n  > small {\n    font-weight: 400;\n    color: ",
        ";\n  }\n"
    ]);
    styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: ",
        ";\n  flex-shrink: 0;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 600;\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-style: italic;\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-shrink: 0;\n  color: ",
        ";\n  display: flex;\n  gap: ",
        ";\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  padding: ",
        " ",
        ";\n\n  &:not(:first-child) {\n    border-top: 1px solid ",
        ";\n  }\n\n  cursor: pointer;\n\n  @media (max-width: 768px) {\n    padding: ",
        " 0;\n    padding: ",
        " ",
        ";\n  }\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n\n  transition: opacity 0.3s;\n\n  &:hover {\n    opacity: 0.65;\n  }\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: ",
        ";\n\n  width: 28px;\n  height: 28px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  background: ",
        ";\n\n  cursor: pointer;\n\n  transition: filter ease-in 0.3s;\n\n  * {\n    cursor: pointer;\n  }\n\n  > svg {\n    width: 12px;\n    height: 12px;\n\n    transition: color ease-in 0.3s;\n  }\n\n  &:hover {\n    filter: brightness(0.97);\n\n    > svg {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 28px;\n  border: 1px solid ",
        ";\n  border-radius: ",
        ";\n  overflow: hidden;\n  flex: 1;\n\n  display: flex;\n  align-items: center;\n\n  > input {\n    flex: 1;\n    border: none;\n    height: 28px;\n    padding: 0 8px;\n    font-size: ",
        ";\n\n    &:disabled {\n      background: ",
        ";\n    }\n  }\n\n  > button {\n    border-left: 1px solid ",
        ";\n\n    width: 28px;\n    height: 28px;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    background: ",
        ";\n\n    cursor: pointer;\n\n    transition: filter ease-in 0.3s;\n\n    * {\n      cursor: pointer;\n    }\n\n    > svg {\n      width: 12px;\n      height: 12px;\n      transition: color ease-in 0.3s;\n    }\n\n    &:hover {\n      filter: brightness(0.97);\n\n      > svg {\n        color: ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}

const styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3fe1c73d-0"
})(styles_templateObject(), (p)=>p.theme.spacing.nano, (p)=>p.theme.font.small, (p)=>p.theme.font.xSmall);
const WrapperImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3fe1c73d-1"
})(styles_templateObject1(), (p)=>p.theme.colors.border, (p)=>p.theme.colors.backgroundHover, (p)=>p.theme.colors.primary);
const Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-3fe1c73d-2"
})(styles_templateObject2());
const Name = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3fe1c73d-3"
})(styles_templateObject3(), (p)=>p.theme.spacing.quark, (p)=>p.theme.colors.textSecondary);
const WrapperPrice = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3fe1c73d-4"
})(_templateObject4(), (p)=>p.theme.spacing.nano);
const Price = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3fe1c73d-5"
})(_templateObject5());
const UnityPrice = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3fe1c73d-6"
})(_templateObject6(), (p)=>p.theme.font.xSmall);
const WrapperAction = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3fe1c73d-7"
})(_templateObject7(), (p)=>p.theme.colors.primary, (p)=>p.theme.spacing.small);
const WrapperProduct = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3fe1c73d-8"
})(_templateObject8(), (p)=>p.theme.spacing.small, (p)=>p.theme.spacing.medium, (p)=>p.theme.spacing.large, (p)=>p.theme.colors.border, (p)=>p.theme.spacing.small, (p)=>p.theme.spacing.small, (p)=>p.theme.spacing.medium);
const ProductInfoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3fe1c73d-9"
})(_templateObject9(), (p)=>p.theme.spacing.medium);
const RemoveProductButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-3fe1c73d-10"
})(_templateObject10(), (p)=>p.theme.colors.border, (p)=>p.theme.borderRadius, (param)=>{
    let { theme  } = param;
    return theme.colors.background;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.danger;
});
const QuantityWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3fe1c73d-11"
})(_templateObject11(), (p)=>p.theme.colors.border, (p)=>p.theme.borderRadius, (p)=>p.theme.font.xSmall, (param)=>{
    let { theme  } = param;
    return theme.colors.background;
}, (p)=>p.theme.colors.border, (param)=>{
    let { theme  } = param;
    return theme.colors.background;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.primary;
});

;// CONCATENATED MODULE: ./src/themes/default/components/Bag/components/Products/Product.tsx







const Product = (param)=>{
    let { item , addOneItem , onClickItem , removeItem , removeOneItem , changeItemQuantity  } = param;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    const isFirstRender = (0,react.useRef)(true);
    const isChangingQuantity = (0,react.useRef)(false);
    const [quantity, setQuantity] = (0,react.useState)(0);
    const debouncedQuantity = hooks_useDebounce(quantity);
    const handleChangeQuantity = (event)=>{
        isChangingQuantity.current = true;
        setQuantity(Number(event.target.value));
    };
    (0,react.useEffect)(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        if (!isChangingQuantity.current) return;
        changeItemQuantity(item, debouncedQuantity);
        isChangingQuantity.current = false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        debouncedQuantity
    ]);
    (0,react.useEffect)(()=>{
        setQuantity(item.quantity);
    }, [
        item.quantity
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperProduct, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductInfoWrapper, {
                onClick: ()=>onClickItem(item.product),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperImage, {
                        children: (item === null || item === void 0 ? void 0 : (ref = item.product) === null || ref === void 0 ? void 0 : (ref1 = ref.pictures) === null || ref1 === void 0 ? void 0 : ref1[0]) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                            src: item === null || item === void 0 ? void 0 : (ref2 = item.product) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.pictures) === null || ref3 === void 0 ? void 0 : ref3[0]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoImageOutline */.tpQ, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Name, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: (item === null || item === void 0 ? void 0 : (ref4 = item.product) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.relatedWith) === null || ref5 === void 0 ? void 0 : ref5.name) || (item === null || item === void 0 ? void 0 : (ref6 = item.product) === null || ref6 === void 0 ? void 0 : ref6.name)
                            }),
                            ((ref7 = item.product) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.relatedWith) === null || ref8 === void 0 ? void 0 : ref8.name) && /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                children: item === null || item === void 0 ? void 0 : (ref9 = item.product) === null || ref9 === void 0 ? void 0 : ref9.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperPrice, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Price, {
                                children: (0,formatCurrency/* formatCurrency */.x)(quantity * (item.unitPrice || 0) || 0)
                            }),
                            quantity > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnityPrice, {
                                children: [
                                    (0,formatCurrency/* formatCurrency */.x)(item.unitPrice || 0),
                                    " cada"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperAction, {
                onClick: (e)=>e.stopPropagation(),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoveProductButton, {
                        type: "button",
                        onClick: ()=>removeItem(item),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiTrash2 */.Ybf, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuantityWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                value: quantity,
                                onChange: handleChangeQuantity
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                onClick: ()=>removeOneItem(item),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiMinus */.ego, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                onClick: ()=>addOneItem(item),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiPlus */.OvN, {})
                            })
                        ]
                    })
                ]
            })
        ]
    }, item._id);
};

;// CONCATENATED MODULE: ./src/themes/default/components/Bag/components/Products/index.tsx



const Products = (param)=>{
    let { items , addOneItem , removeOneItem , onClickItem , removeItem , changeItemQuantity  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Wrapper, {
        children: items === null || items === void 0 ? void 0 : items.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Product, {
                item: item,
                addOneItem: addOneItem,
                removeOneItem: removeOneItem,
                onClickItem: onClickItem,
                removeItem: removeItem,
                changeItemQuantity: changeItemQuantity
            }, item._id))
    });
};

;// CONCATENATED MODULE: ./src/themes/default/components/Bag/components/EmptyBag/styles.ts

function EmptyBag_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  align-self: center;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  max-width: 250px;\n\n  text-align: center;\n\n  gap: ",
        ";\n\n  color: ",
        ";\n"
    ]);
    EmptyBag_styles_templateObject = function() {
        return data;
    };
    return data;
}
function EmptyBag_styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  font-size: ",
        ";\n  padding: ",
        ";\n  margin-bottom: ",
        ";\n\n  border: 1px dashed ",
        ";\n  border-radius: 100%;\n\n  & > svg {\n    stroke-width: 1.5px;\n  }\n"
    ]);
    EmptyBag_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function EmptyBag_styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n"
    ]);
    EmptyBag_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function EmptyBag_styles_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: ",
        ";\n"
    ]);
    EmptyBag_styles_templateObject3 = function() {
        return data;
    };
    return data;
}

const EmptyBag_styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8f403252-0"
})(EmptyBag_styles_templateObject(), (p)=>p.theme.spacing.small, (p)=>p.theme.colors.textSecondary);
const WrapperIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8f403252-1"
})(EmptyBag_styles_templateObject1(), (p)=>p.theme.colors.primary, (p)=>p.theme.spacing.xLarge, (p)=>p.theme.spacing.xxLarge, (p)=>p.theme.spacing.medium, (p)=>p.theme.colors.primary);
const styles_Title = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-8f403252-2"
})(EmptyBag_styles_templateObject2(), (p)=>p.theme.font.large);
const Description = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-8f403252-3"
})(EmptyBag_styles_templateObject3(), (p)=>p.theme.font.small, (p)=>p.theme.spacing.medium);

;// CONCATENATED MODULE: ./src/themes/default/components/Bag/components/EmptyBag/index.tsx



const EmptyBag = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmptyBag_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperIcon, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiShoppingBag */.x8h, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Title, {
                children: "Sua sacola est\xe1 vazia."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                children: "Volte para o cat\xe1logo para adicionar produtos."
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/utils/masks.ts
var masks = __webpack_require__(4201);
;// CONCATENATED MODULE: ./src/themes/default/components/Bag/styles.ts

function Bag_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    transform: translateX(100%);\n  }\n\n  100% {\n    transform: translateX(0);\n  }\n"
    ]);
    Bag_styles_templateObject = function() {
        return data;
    };
    return data;
}
function Bag_styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    transform: translateX(0);\n  }\n\n  100% {\n    transform: translateX(100%);\n  }\n"
    ]);
    Bag_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function Bag_styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n"
    ]);
    Bag_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function Bag_styles_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n"
    ]);
    Bag_styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n\n  background-color: rgba(0, 0, 0, 0.25);\n\n  animation: ",
        " 0.3s ease-in-out;\n"
    ]);
    styles_templateObject4 = function() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n\n  max-width: 420px;\n\n  background-color: ",
        ";\n\n  display: flex;\n  flex-direction: column;\n\n  animation: ",
        " 0.3s ease-in-out;\n\n  overflow: auto;\n\n  width: 100%;\n"
    ]);
    styles_templateObject5 = function() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n\n  z-index: 1000;\n\n  &.isHidden {\n    ",
        " {\n      animation: ",
        " 0.3s ease-in-out;\n      transform: translateX(100%);\n    }\n\n    ",
        " {\n      opacity: 0;\n      animation: ",
        " 0.3s ease-in-out;\n    }\n  }\n"
    ]);
    styles_templateObject6 = function() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: ",
        ";\n  padding: ",
        " ",
        "\n    ",
        ";\n\n  border-bottom: 1px solid ",
        ";\n\n  position: sticky;\n  top: 0;\n\n  @media (max-width: 768px) {\n    font-size: ",
        ";\n\n    padding: ",
        ";\n  }\n"
    ]);
    styles_templateObject7 = function() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n  text-transform: uppercase;\n\n  @media (max-width: 768px) {\n    font-size: ",
        ";\n  }\n"
    ]);
    styles_templateObject8 = function() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        " ",
        ";\n\n  border-top: 1px solid ",
        ";\n"
    ]);
    styles_templateObject9 = function() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  color: ",
        ";\n  background-color: transparent;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: ",
        ";\n\n  & svg {\n    stroke-width: 3;\n  }\n"
    ]);
    styles_templateObject10 = function() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n\n  gap: ",
        ";\n  padding: ",
        " ",
        "\n    ",
        ";\n\n  border-top: 1px solid ",
        ";\n\n  & > button {\n    flex: 1;\n  }\n\n  @media (max-width: 768px) {\n    flex-direction: column;\n    padding: ",
        ";\n\n    & > button {\n      font-size: ",
        ";\n    }\n  }\n"
    ]);
    styles_templateObject11 = function() {
        return data;
    };
    return data;
}

const slideToLeft = (0,styled_components_browser_esm/* keyframes */.F4)(Bag_styles_templateObject());
const slideToRight = (0,styled_components_browser_esm/* keyframes */.F4)(Bag_styles_templateObject1());
const fadeIn = (0,styled_components_browser_esm/* keyframes */.F4)(Bag_styles_templateObject2());
const fadeOut = (0,styled_components_browser_esm/* keyframes */.F4)(Bag_styles_templateObject3());
const Overlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a3ee1643-0"
})(styles_templateObject4(), fadeIn);
const Drawer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a3ee1643-1"
})(styles_templateObject5(), (p)=>p.theme.colors.background, slideToLeft);
const Bag_styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a3ee1643-2"
})(styles_templateObject6(), Drawer, slideToRight, Overlay, fadeOut);
const Header = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a3ee1643-3"
})(styles_templateObject7(), (p)=>p.theme.colors.background, (p)=>p.theme.spacing.large, (p)=>p.theme.spacing.large, (p)=>p.theme.spacing.medium, (p)=>p.theme.colors.border, (p)=>p.theme.font.large, (p)=>p.theme.spacing.medium);
const Bag_styles_Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-a3ee1643-4"
})(styles_templateObject8(), (p)=>p.theme.colors.textPrimary, (p)=>p.theme.font.xLarge, (p)=>p.theme.font.large);
const WrapperDelivery = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a3ee1643-5"
})(styles_templateObject9(), (p)=>p.theme.spacing.medium, (p)=>p.theme.spacing.large, (p)=>p.theme.colors.border);
const ButtonClose = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-a3ee1643-6"
})(styles_templateObject10(), (p)=>p.theme.colors.textPrimary, (p)=>p.theme.font.xLarge);
const WrapperFooter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a3ee1643-7"
})(styles_templateObject11(), (p)=>p.theme.spacing.small, (p)=>p.theme.spacing.medium, (p)=>p.theme.spacing.large, (p)=>p.theme.spacing.large, (p)=>p.theme.colors.border, (p)=>p.theme.spacing.medium, (p)=>p.theme.font.xSmall);

;// CONCATENATED MODULE: ./src/themes/default/components/Bag/index.tsx









const Bag = (param)=>{
    let { goToCart , goToCheckout , isHidden , isOpen , handleClose , cart , addOneItem , removeOneItem , onClickItem , onClickCalculateShipping , shippingOptions , selectShipping , shippingSelected , postalCode , discount , pickup , removeItem , changeItemQuantity  } = param;
    var ref, ref1;
    if (!isOpen) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Bag_styles_Wrapper, {
        className: isHidden ? "isHidden" : "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay, {
                onClick: handleClose
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bag_styles_Title, {
                                children: "SACOLA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonClose, {
                                onClick: handleClose,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiX */.q5L, {})
                            })
                        ]
                    }),
                    !(cart === null || cart === void 0 ? void 0 : (ref = cart.items) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyBag, {}),
                    ((cart === null || cart === void 0 ? void 0 : (ref1 = cart.items) === null || ref1 === void 0 ? void 0 : ref1.length) || 0) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Products, {
                                onClickItem: onClickItem,
                                items: cart === null || cart === void 0 ? void 0 : cart.items,
                                addOneItem: addOneItem,
                                removeOneItem: removeOneItem,
                                removeItem: removeItem,
                                changeItemQuantity: changeItemQuantity
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperDelivery, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Delivery/* Delivery */.o, {
                                    postalCode: (0,masks/* maskPostalCode */.Sd)(postalCode || ""),
                                    selectShipping: selectShipping,
                                    shippingSelected: shippingSelected,
                                    shippingOptions: shippingOptions,
                                    onClickCalculateShipping: onClickCalculateShipping,
                                    manufacturingTime: cart === null || cart === void 0 ? void 0 : cart.manufacturingTime,
                                    pickup: pickup
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Resume, {
                                shippingSelected: shippingSelected,
                                total: cart === null || cart === void 0 ? void 0 : cart.total,
                                discount: discount
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperFooter, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                                        onClick: goToCart,
                                        transparent: true,
                                        font: "small",
                                        children: "VER CARRINHO"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                                        onClick: goToCheckout,
                                        font: "small",
                                        children: "FINALIZAR COMPRA"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_Bag = (Bag);


/***/ })

}]);